import { dynamicHead } from '@/mixins/dynamic-head';

export default {
  name: 'ServerError',
  mixins: [dynamicHead],
  created() {
    this.metaParams.prerender = {
      content: '500'
    };
    this.setMeta();
  }
};
